// material
import {
  Container,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableFooter,
  TablePagination,
  Stack,
  Typography,
  Paper,
  List,
  ListItem,
  FormControlLabel,
  Checkbox,
  IconButton,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Slide,
  Alert
} from '@mui/material';
// hooks
import useSettings from '../../hooks/useSettings';
// components
import Page from '../../components/Page';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import { PATH_DASHBOARD } from '../../routes/paths';
import { generatePath, NavLink, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from '../../utils/axios';
import { Fragment, useEffect, useState } from 'react';
import {
  AlarmState,
  AlarmStateChange,
  DATE_TIME_FORMAT_SHORT,
  Device,
  Measure,
  RefactoredDevice,
  show_date
} from '../../@types/model/device';
import dayjs, { Dayjs } from 'dayjs';
import LoadingSpinner from '../../components/LoadingSpinner';
// import BaseOptionChart from '../../components/charts/BaseChartOptions';
// import ReactApexChart from 'react-apexcharts';

// TIMELINE
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import { RootState, useSelector } from '../../redux/store';
import { AlarmDefinition, DeviceType } from '../../@types/model/user';
import { v4 } from 'uuid';
import { ChartDataPoint, getDevice, putMeasure } from '../../api';
import BasicModal from '../../components/BasicModal';
import * as React from 'react';
import { ReactJSXElement } from '@emotion/react/types/jsx-namespace';
import SvgIconStyle from '../../components/SvgIconStyle';
import { MIconButton } from '../../components/@material-extend';
import { Icon } from '@iconify/react';
import closeFill from '@iconify/icons-eva/close-fill';
import { useSnackbar } from 'notistack';
import { DateRange, DateRangePicker, LoadingButton } from '@mui/lab';
import { TransitionProps } from '@mui/material/transitions';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DayjsUtils from '@date-io/dayjs';
import { checkRoles, ROLE_USER } from 'guards/CheckRoles';
import refactorDevices from 'components/device/Components/refactorDevices';
import DeviceDetailsDashboard from './DeviceDetailsDashboard';
// import { checkWorkspace, WORKSPACES_REPSOL } from 'guards/CheckRoles';

const Transition: any = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// ----------------------------------------------------------------------

const addAlarmToDevice = (
  deviceGuid: string,
  guid: string,
  alarm: string | null,
  tag: string | null
) => {
  return axios.post(`/api/v2/device/${deviceGuid}/alarm-state`, {
    guid,
    alarm,
    tag
  });
};
const removeAlarmFromDevice = (alarmStateGuid: string) => {
  return axios.delete(`/api/v2/device/${alarmStateGuid}/alarm-state`);
};

function DeviceDetails() {
  const { user } = useSelector((state: RootState) => state.user);
  const { guid } = useParams();
  const { themeStretch } = useSettings();
  const { t } = useTranslation();
  const [measures, setMeasures] = useState<Measure[]>([]);
  const [measuresPage, setMeasuresPage] = useState<number>(0);
  const [device, setDevice] = useState<Device | null>(null);
  const [refactoredDevice, setRefactoredDevice] = useState<RefactoredDevice | null>(null);
  const [measuresPerPage, setMeasuresPerPage] = useState<number>(50);
  const [availableMetrics, setAvailableMetrics] = useState<string[]>([]);
  const [updatedMeasure, setUpdatedMeasure] = useState<undefined | Measure>(undefined);
  const [updatingMeasure, setUpdatingMeasure] = useState<boolean>(false);
  const [alarmStateChanges, setAlarmStateChanges] = useState<AlarmStateChange[]>([]);
  const [alarmState, setAlarmState] = useState<AlarmState[]>([]);
  const [chartData, setChartData] = useState<ChartDataPoint[]>([]);
  const [graphToShow, setGraphToShow] = useState<string>('Remain');

  const navigate = useNavigate();
  const [updatingAlarms, setUpdatingAlarms] = useState(false);

  const { loaded, alarmDefinitions } = useSelector((state: RootState) => state.user);
  const role = checkRoles(user, ROLE_USER) ? '/' : '/end-user';

  const [modalDetailContent, setModalDetailContent] = useState<undefined | ReactJSXElement>();

  const [deviceToDelete, setDeviceToDelete] = useState<undefined | string>();

  const [receivedDataTableIsLoading, setReceivedDataTableIsLoading] = useState(false);
  const [dateRangeValue, setDateRangeValue] = React.useState<DateRange<Dayjs>>([
    dayjs().subtract(15, 'day'),
    dayjs()
  ]);

  const deleteDevice = (deviceGuid: string) => {
    return axios.delete(`/api/v2/device/${deviceGuid}`).then(() => {
      navigate(generatePath(PATH_DASHBOARD.devices.list));
    });
  };

  const loadDeviceData = () => {
    getDevice(
      guid!,
      dateRangeValue[0]!.hour(0).minute(0).second(0),
      dateRangeValue[1]!.hour(23).minute(59).second(59),
      (
        device: Device,
        measures: Measure[],
        chartData: ChartDataPoint[],
        deviceType: DeviceType,
        availableMetrics: string[],
        alarmStateChanges: AlarmStateChange[],
        alarmState: AlarmState[]
      ) => {
        setDevice(device);
        setRefactoredDevice(refactorDevices([device])[0]);
        setMeasures(measures);
        setAvailableMetrics(availableMetrics);
        setAlarmStateChanges(alarmStateChanges);
        setAlarmState(alarmState);
        setUpdatingAlarms(false);
        setReceivedDataTableIsLoading(false);
        chartData.forEach((item) => {
          if (item.name === 'Kilos') setGraphToShow('Kilos');
        });
        setChartData(chartData.filter((item) => item.name !== 'RawSensor'));
      }
    );
  };
  useEffect(() => {
    loadDeviceData();
  }, [dateRangeValue, guid]);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  /* --------------------- chart ---------------------*/
  let capacidad = 0;
  device?.attributes.parameters.forEach((param) => {
    if (param.identifier === 'capacidad') capacidad = parseInt(param.value);
  });
  // const chartOptions = merge(BaseOptionChart(), {
  //   /* xaxis: {
  //     categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep']
  //   }, */
  //   xaxis: {
  //     type: 'date',
  //     tickAmount: 10,
  //     labels: {
  //       formatter: function (val: number) {
  //         return show_date(val * 1000);
  //       },
  //       hideOverlappingLabels: true,
  //       rotate: -45,
  //       rotateAlways: true,
  //       trim: false
  //     },
  //     tooltip: {
  //       x: { show: false },
  //       marker: { show: false }
  //     }
  //   },
  //   yaxis: [
  //     {
  //       title: {
  //         text: graphToShow
  //       },
  //       seriesName: graphToShow,
  //       min: 0,
  //       max: capacidad,
  //       decimalsInFloat: 0
  //     },
  //     {
  //       opposite: true,
  //       title: {
  //         text: 'Percent'
  //       },
  //       seriesName: 'Percent',
  //       min: 0,
  //       max: 130,
  //       show: false,
  //       decimalsInFloat: 0
  //     },
  //     {
  //       opposite: true,
  //       title: {
  //         text: 'Temperature'
  //       },
  //       seriesName: 'Temperature',
  //       min: 0,
  //       max: 130, // Carlos: Fondo de escala establecido para mejorar la representación de la gráfica
  //       decimalsInFloat: 0,
  //       show: false
  //     },
  //     {
  //       title: {
  //         text: 'Distance'
  //       },
  //       seriesName: 'Distance',
  //       show: false
  //     },
  //     {
  //       title: {
  //         text: 'RawSensor'
  //       },
  //       seriesName: 'RawSensor',
  //       show: false
  //     },
  //     {
  //       seriesName: 'BatteryLevel',
  //       show: false
  //     }
  //   ]
  // });

  if (!device || !loaded) {
    return <LoadingSpinner />;
  }
  const pageTitle =
    device.attributes.name.length > 0 ? device.attributes.name : device.attributes.identifier;

  let deviceGuid = device.guid;
  if (device.attributes.is_ref_of) {
    if (user?.attributes.configuration?.allow_edit_shared_devices) {
      if (device.attributes.is_ref_of.split(':').length === 3) {
        deviceGuid = device.attributes.is_ref_of.split(':')[2];
      }
    }
  }

  return (
    <Page title={pageTitle}>
      <Container maxWidth={themeStretch ? false : 'xl'}>
        <HeaderBreadcrumbs
          heading={pageTitle}
          links={[
            { name: t('home'), href: role },
            { name: t('devices'), href: PATH_DASHBOARD.devices.list },
            {
              name: t('device_details_breadcrumb', { device_name: pageTitle }),
              href: generatePath(PATH_DASHBOARD.devices.edit, { guid: device.guid })
            }
          ]}
          action={
            checkRoles(user, ROLE_USER) ? (
              <Button
                variant={'outlined'}
                component={NavLink}
                to={generatePath(PATH_DASHBOARD.devices.edit, { guid: deviceGuid })}
                disabled={
                  device?.attributes.is_ref_of !== null &&
                  !user?.attributes.configuration?.allow_edit_shared_devices
                }
              >
                {t('edit')}
              </Button>
            ) : (
              <></>
            )
          }
        />
        <div style={{ display: 'flex' }}>
          {refactoredDevice?.calibrado === false ? (
            <Alert style={{ marginLeft: '10px' }} variant="filled" severity="error">
              {t('pending_calibration')}
            </Alert>
          ) : null}
        </div>

        <DeviceDetailsDashboard TransitionComponent={Transition} />

        {checkRoles(user, ROLE_USER) ? (
          <Stack direction={'row'}>
            <Paper>
              <Typography variant={'h5'}>{t('alarms')}</Typography>
              <List>
                {alarmDefinitions.map((ad: AlarmDefinition) => {
                  const as = alarmState.find((as: AlarmState) => {
                    if (as.attributes) return as.attributes.alarm_definition === ad.guid;
                    return false;
                  });
                  return (
                    <ListItem key={ad.guid}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            disabled={updatingAlarms}
                            checked={as !== undefined}
                            onClick={(event: any) => {
                              setUpdatingAlarms(true);
                              if (event.target.checked) {
                                addAlarmToDevice(device.guid, v4(), ad.guid, null).then(() => {
                                  loadDeviceData();
                                });
                              } else {
                                if (as !== undefined) {
                                  removeAlarmFromDevice(as.guid).then(() => {
                                    loadDeviceData();
                                  });
                                }
                              }
                            }}
                          />
                        }
                        label={ad.attributes.name}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Paper>
            <Paper sx={{ overflowY: 'scroll', maxHeight: 300 }}>
              <Typography variant={'h5'} textAlign={'center'}>
                {t('alarm_state_change_list')}
              </Typography>
              <Timeline sx={{ width: '100%' }}>
                {alarmStateChanges.map((asc: AlarmStateChange) => {
                  const alarm: undefined | AlarmDefinition =
                    alarmState.length > 0
                      ? alarmDefinitions.find((ad: AlarmDefinition) => {
                          if (ad.attributes) {
                            let findAs = alarmState.find((as: AlarmState) => {
                              if (
                                typeof as !== 'undefined' &&
                                as.attributes &&
                                typeof as.attributes.alarm_definition !== 'undefined'
                              ) {
                                return as.attributes.alarm_definition === ad.guid;
                              }
                              return false;
                            });
                            if (!findAs) return false;
                            return ad.guid === findAs!.attributes.alarm_definition;
                          }
                          return false;
                        })
                      : undefined;
                  return (
                    <TimelineItem key={`alarm-state-change-${asc.guid}`}>
                      <TimelineOppositeContent color="text.secondary">
                        {show_date(asc.attributes.created, DATE_TIME_FORMAT_SHORT)}
                      </TimelineOppositeContent>
                      <TimelineSeparator>
                        <TimelineDot
                          color={asc.attributes.alarm_state === 'alarm' ? 'error' : 'success'}
                        />
                        <TimelineConnector />
                      </TimelineSeparator>
                      <TimelineContent>
                        {alarm
                          ? t('alarm_state_change_desc', {
                              alarm_name: alarm.attributes.name,
                              alarm_state: asc.attributes.alarm_state
                            })
                          : null}
                      </TimelineContent>
                    </TimelineItem>
                  );
                })}
              </Timeline>
            </Paper>
          </Stack>
        ) : (
          <></>
        )}

        <Typography variant={'h5'}>{t('received_data')}</Typography>
        <LocalizationProvider dateAdapter={DayjsUtils} locale={navigator.language.split('-')[0]}>
          <DateRangePicker
            startText={t('start_date')}
            endText={t('end_date')}
            value={dateRangeValue}
            onChange={(newValue) => {
              setReceivedDataTableIsLoading(true);
              setDateRangeValue(newValue);
            }}
            renderInput={(startProps, endProps) => (
              <React.Fragment>
                <TextField
                  {...startProps}
                  inputProps={{ ...startProps.inputProps, readOnly: true }}
                />
                <TextField
                  {...endProps}
                  inputProps={{ ...endProps.inputProps, readOnly: true }}
                  style={{ marginLeft: '10px', marginTop: '40px' }}
                />
              </React.Fragment>
            )}
          />
        </LocalizationProvider>
        <Table id="tabla-datos-recibidos">
          <TableHead>
            <TableRow>
              <TableCell style={{ textAlign: 'center' }}>{t('date')}</TableCell>
              {availableMetrics.map((mNanme: string) => {
                const discardFields = [
                  'Weight',
                  'Temperature',
                  'RawSensor',
                  'ReceivedWeight',
                  'Distance',
                  'OrignalRemain',
                  'Height',
                  'BatteryLevel',
                  'RemainSmoothed'
                ];
                //const fieldsToAdd = ['Remain', 'Percent', 'Height'];
                if (discardFields.includes(mNanme)) return null;
                return (
                  <TableCell style={{ textAlign: 'center' }} key={'metric-name-' + mNanme}>
                    {t(`${mNanme.toLocaleLowerCase()}`)}{' '}
                  </TableCell>
                );
              })}
              <TableCell style={{ textAlign: 'center' }}>{t('free_space')}</TableCell>
              {!device.attributes.is_ref_of && checkRoles(user, ROLE_USER) ? (
                <TableCell style={{ textAlign: 'center' }}>{t('edit')}</TableCell>
              ) : null}
            </TableRow>
          </TableHead>
          {!receivedDataTableIsLoading ? (
            <TableBody>
              {measures
                .slice(
                  measuresPage * measuresPerPage,
                  measuresPage * measuresPerPage + measuresPerPage
                )
                .map((m: Measure) => {
                  let remain: any;
                  return (
                    <TableRow key={m.guid}>
                      <TableCell style={{ textAlign: 'center' }}>
                        {show_date(m.attributes.date, DATE_TIME_FORMAT_SHORT)}
                      </TableCell>
                      {availableMetrics.map((mNanme: string) => {
                        const discardFields = [
                          'Weight',
                          'Temperature',
                          'RawSensor',
                          'ReceivedWeight',
                          'Distance',
                          'OrignalRemain',
                          'Height',
                          'BatteryLevel',
                          'RemainSmoothed'
                        ];

                        if (discardFields.includes(mNanme)) return null;
                        const datum = m.attributes.data.find((item) => {
                          return item.name === mNanme;
                        });
                        if (datum) {
                          if (datum.name === 'Remain') remain = datum.value;
                          if (datum.name === 'Kilos') remain = datum.value;
                          if (datum.type === 'picture_data') {
                            return (
                              <TableCell
                                style={{ textAlign: 'center' }}
                                key={'metric-name-' + mNanme + m.guid}
                              >
                                <img
                                  onClick={() => {
                                    setModalDetailContent(
                                      <img
                                        src={datum.value}
                                        alt={mNanme}
                                        style={{ minWidth: '250px' }}
                                      />
                                    );
                                  }}
                                  src={datum.value}
                                  alt={mNanme}
                                  style={{
                                    maxHeight: '80px',
                                    maxWidth: '250px',
                                    cursor: 'zoom-in'
                                  }}
                                />
                              </TableCell>
                            );
                          } else {
                            let value_show = datum.value;
                            if (mNanme === 'Percent') value_show += '%';
                            if (mNanme === 'Kilos') value_show += 'Kg';
                            if (mNanme === 'Temperature') value_show += 'ºC';
                            if (mNanme === 'Remain') value_show += refactoredDevice?.unit;
                            return (
                              <TableCell
                                style={{ textAlign: 'center' }}
                                key={'metric-name-' + mNanme + m.guid}
                              >
                                {value_show}
                              </TableCell>
                            );
                          }
                        } else {
                          return (
                            <TableCell
                              style={{ textAlign: 'center' }}
                              key={'metric-name-' + mNanme + m.guid}
                            ></TableCell>
                          );
                        }
                      })}
                      <TableCell style={{ textAlign: 'center' }}>
                        {capacidad && remain ? capacidad - remain : 0}
                        {refactoredDevice?.unit}
                      </TableCell>
                      {!device.attributes.is_ref_of && checkRoles(user, ROLE_USER) ? (
                        <TableCell style={{ textAlign: 'center' }}>
                          <IconButton
                            onClick={() => {
                              setUpdatedMeasure(m);
                            }}
                          >
                            <SvgIconStyle
                              src="/static/icons/giraf/edit.svg"
                              sx={{ width: '20px', height: '20px' }}
                            />
                          </IconButton>
                        </TableCell>
                      ) : null}
                    </TableRow>
                  );
                })}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell />
              </TableRow>
            </TableBody>
          )}
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[50, 100, 200]}
                count={measures.length}
                rowsPerPage={measuresPerPage}
                page={measuresPage}
                onPageChange={(event: any, page: number) => {
                  setMeasuresPage(page);
                }}
                onRowsPerPageChange={(event: any) => {
                  setMeasuresPerPage(parseInt(event.target.value, 10));
                }}
              />
            </TableRow>
          </TableFooter>
        </Table>
        {!device.attributes.is_ref_of && checkRoles(user, ROLE_USER) ? (
          <Button
            variant="outlined"
            color={'error'}
            onClick={() => {
              setDeviceToDelete(device.guid);
            }}
          >
            {t('device_delete_cta')}
          </Button>
        ) : null}
        <Dialog
          open={deviceToDelete !== undefined}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => {
            setDeviceToDelete(undefined);
          }}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>{t('device_delete_confirm')}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {t('device_delete_confirm_dialog')}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setDeviceToDelete(undefined);
              }}
            >
              {t('cancel')}
            </Button>
            <Button
              onClick={() => {
                deleteDevice(device.guid);
              }}
            >
              {t('confirm')}
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
      <BasicModal
        open={modalDetailContent !== undefined}
        handleClose={() => {
          setModalDetailContent(undefined);
        }}
      >
        {modalDetailContent ? (
          <Fragment>
            {modalDetailContent}
            <Button
              onClick={() => {
                setModalDetailContent(undefined);
              }}
            >
              {t('close')}
            </Button>
          </Fragment>
        ) : null}
      </BasicModal>
      <BasicModal
        open={updatedMeasure !== undefined}
        handleClose={() => {
          setUpdatedMeasure(undefined);
        }}
      >
        <Stack spacing={3}>
          <Typography variant={'h4'}>{t('update_measure_text')}</Typography>
          {updatedMeasure
            ? updatedMeasure.attributes.data.map(
                (datum: { type: string; value: any; name: string }) => {
                  if (datum) {
                    if (datum.type === 'picture_data') {
                      return (
                        <img
                          key={`${datum.type}_${datum.name}`}
                          onClick={() => {
                            setModalDetailContent(
                              <img
                                src={datum.value}
                                alt={datum.name}
                                style={{ minWidth: '250px' }}
                              />
                            );
                          }}
                          src={datum.value}
                          alt={datum.name}
                          style={{ maxHeight: '80px', maxWidth: '250px', cursor: 'zoom-in' }}
                        />
                      );
                    } else {
                      return (
                        <TextField
                          key={`${datum.type}_${datum.name}`}
                          fullWidth
                          type="number"
                          value={datum.value}
                          label={datum.name}
                          onChange={(event) => {
                            setUpdatedMeasure({
                              guid: updatedMeasure.guid,
                              attributes: {
                                ...updatedMeasure.attributes,
                                data: updatedMeasure.attributes.data.map(
                                  (measureData: { type: string; value: any; name: string }) => {
                                    if (measureData.name === datum.name) {
                                      return {
                                        ...measureData,
                                        value: parseFloat(event.target.value)
                                      };
                                    } else {
                                      return measureData;
                                    }
                                  }
                                )
                              }
                            } as Measure);
                          }}
                        />
                      );
                    }
                  }
                  return null;
                }
              )
            : null}
        </Stack>
        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={updatingMeasure}
          sx={{ my: 2 }}
          onClick={() => {
            setUpdatingMeasure(true);
            putMeasure(
              updatedMeasure!,
              () => {
                setUpdatingMeasure(false);
                setUpdatedMeasure(undefined);
                enqueueSnackbar(t('measure_updated'), {
                  variant: 'success',
                  action: (key) => (
                    <MIconButton size="small" onClick={() => closeSnackbar(key)}>
                      <Icon icon={closeFill} />
                    </MIconButton>
                  )
                });
                loadDeviceData();
              },
              () => {
                setUpdatingMeasure(false);
                enqueueSnackbar(t('measure_updated_error'), {
                  variant: 'error',
                  action: (key) => (
                    <MIconButton size="small" onClick={() => closeSnackbar(key)}>
                      <Icon icon={closeFill} />
                    </MIconButton>
                  )
                });
              }
            );
          }}
        >
          {t('edit')}
        </LoadingButton>
      </BasicModal>
    </Page>
  );
}

export default DeviceDetails;
